import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@chakra-ui/react'
import { AuthProvider } from './contexts/AuthContext'
import { BexcoProvider } from './contexts/BexcoContext'
import LoginPage from './pages/LoginPage'
import AdminLayout from './components/AdminLayout'
import DashboardPage from './pages/DashboardPage'
import FaqManagementPage from './pages/FaqManagementPage'
import QueryLogsPage from './pages/QueryLogsPage'
import FileManagementPage from './pages/FileManagementPage'
import PromptRulesPage from './pages/PromptRulesPage'
import SettingsPage from './pages/SettingsPage'
import CrawlerLogsPage from './pages/CrawlerLogsPage'
import UserGuidePage from './pages/UserGuidePage'
import InquiryBoardPage from './pages/InquiryBoardPage'
import ValidationReportPage from './pages/ValidationReportPage'
import WorkflowLogsPage from './pages/WorkflowLogsPage'
import AnalysisReportPage from './pages/AnalysisReportPage'
import AnnouncementPage from './pages/AnnouncementPage'

function App() {
  return (
    <AuthProvider>
      <BexcoProvider>
        <Box minH="100vh" bg="gray.50">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="faqs" element={<FaqManagementPage />} />
              <Route path="logs" element={<QueryLogsPage />} />
              <Route path="crawler-logs" element={<CrawlerLogsPage />} />
              <Route path="files" element={<FileManagementPage />} />
              <Route path="prompt-rules" element={<PromptRulesPage />} />
              <Route path="inquiry-board" element={<InquiryBoardPage />} />
              <Route path="validation-report" element={<ValidationReportPage />} />
              <Route path="workflow-logs" element={<WorkflowLogsPage />} />
              <Route path="analysis-report" element={<AnalysisReportPage />} />
              <Route path="announcements" element={<AnnouncementPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="user-guide" element={<UserGuidePage />} />
            </Route>
          </Routes>
        </Box>
      </BexcoProvider>
    </AuthProvider>
  )
}

export default App





